import React from "react";
import { Typography, Button, Box } from "@mui/material";
import { Primary } from './Buttons';
import { useNavigate } from "react-router-dom";
import { useTheme } from "@emotion/react";
import { Add, Create } from "@mui/icons-material";

const NoData = ({ Actions = () => { }, sx = {}, placeHolderImage, placeHolderSx = {}, title = "No Data Available", subTitle = "It seems like there is no data available at the moment." }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="calc(100% - 164px)"
      textAlign="center"
      padding={3}
      sx={{ ...sx }}
      height={"60dvh"}
      // height={"100%"}
      width={"-webkit-fill-available"}
    // width={"100%"}
    >
      {placeHolderImage && <img
        src={placeHolderImage} // Replace with your image path
        // alt="No Data"
        style={{ width: '200px', height: 200, marginBottom: '20px', background: '', borderRadius: 8, ...placeHolderSx }} // Adjust the size as needed
      />}
      <Typography variant="title" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body1" marginBottom={2} gutterBottom>
        {subTitle}
      </Typography>
      <Actions />
      {/* <Primary onClick={() => navigate("/rounds/create_round")} sx={{ bgcolor: theme.palette.customColors.indigo600, border: `1px solid ${theme.palette.customColors.indigo600}`, padding: '10px 16px', fontWeight: 600 }}
            // startIcon={<Create fontSize='1.25rem' />}
            >
                
            </Primary> */}
    </Box>
  );
};

export default NoData;
